import { track, useTracking } from 'lib/analytics'
import { Reservation } from 'src/types/reservation'
import { Registry } from 'src/types/registry'
import useCurrentUser from 'shared/hooks/useCurrentUser/useCurrentUser'

interface UseTrackUnmarkedAsPurchasedProps {
  registry?: Registry
  reservation: Reservation
}

const convertToNumberWithDefault = (
  num: string | null | undefined,
  defaultNum = 0
) => {
  if (!num) return defaultNum
  const numAsFloat = parseFloat(num)
  return Number.isNaN(numAsFloat) ? defaultNum : numAsFloat
}

const useTrackUnmarkedAsPurchased = ({
  registry,
  reservation,
}: UseTrackUnmarkedAsPurchasedProps) => {
  const tracker = useTracking()
  const [currentUser] = useCurrentUser()

  const regItemPrice = convertToNumberWithDefault(reservation.regItem.price)
  const regItemQuantity = convertToNumberWithDefault(
    reservation.regItem.quantity,
    1
  )

  return () => {
    tracker.trackEvent({
      event: track.reservationUpdated,
      eventCta: null,
      eventType: track.EventType.MARK_AS_UNPURCHASED,
      eventUrl: null,
      productPrice: regItemPrice,
      regItemPrice,
      regItemQuantity,
      userId: currentUser?.id,
      registry,
      reservation,
    })
  }
}

export default useTrackUnmarkedAsPurchased
